export default {
  companyStructureMetadata: {
    fixateChangesButton: 'Fixate changes',
    fixateChangesCaption: 'Recent changes are not fixed',
    noTeamGroups: 'There are no divisions',
    newTeamGroupName: 'New division',
    createTeamGroupButton: 'Add a division',
    stubTitle: 'Select<br/>a division',
    stubText: 'To configure its parameters',
    divisionSettings: 'Configuration the division',
    name: 'Name',
    parent: 'Parent division',
    description: 'Description',
    supervisors: 'Supervisors',
    teams: 'Teams',
    enterName: 'Enter a name',
    shortDescription: 'Brief description of the division',
    createDivisions: 'Create a new divisions?',
    createButton: 'Yes, create',
    deleteDivision: 'Delete the division?',
    successMessages: {
      changeAllTeamGroup: 'The division successfully changed',
      createTeamGroup: 'The division successfully created',
      deleteTeamGroup: 'The division successfully deleted',
    },
    errorMessages: {
      changeAllTeamGroup: 'Failed to change the division',
      createTeamGroup: 'Failed to create the division',
      deleteTeamGroup: 'Failed to delete the division',
    },
  },
};
